import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../library/button/button';
import Select from '../../library/select/select';
import Review from './components/review/review';

import { trackAction } from '../../shared/utils/analytics/analytics';
import { ChildrenProp } from '../../shared/utils/prop-types/prop-types';

import './reviews.scss';

function Reviews(props) {
  const {
    filters,
    sortOptions,
    selectedFilters,
    selectedSort,
    onFilterChange,
    onSortChange,
    onLoadMore,
    showLoadMore,
    children
  } = props;

  return (
    <div className="reviews" styleName="container">
      <form aria-label="Review filter and sort" styleName="filter-sort">
        <div styleName="filters">
          {Array.isArray(filters) &&
            filters.map((filter, idx) => {
              let value = null;
              const selectedOption =
                typeof selectedFilters === 'object' && filter?.code
                  ? selectedFilters[filter.code]
                  : {};

              if (selectedOption?.value) {
                value = selectedOption;
              }

              return (
                <div key={`${filter?.label}-${idx}`} styleName="filter-wrapper">
                  <Select
                    className="filter"
                    hideResetButton
                    label={filter?.label}
                    onChange={option => onFilterChange(option, filter)}
                    options={filter?.options?.filter(f => Boolean(f?.value))}
                    value={value}
                  />
                </div>
              );
            })}
        </div>

        <Select
          hideResetButton
          label="Sort"
          onChange={onSortChange}
          options={sortOptions}
          renderOption={option => (
            <div
              className="react-select__option"
              styleName={
                option?.shouldResetFilter ? 'pseudo-not-selectable' : ''
              }
            >
              {option.label}
            </div>
          )}
          styleName="sort"
          value={selectedSort}
        />
      </form>

      <div styleName="reviews">{children}</div>

      {showLoadMore && (
        <div styleName="load-more">
          <Button
            isSecondary
            onClick={() => {
              onLoadMore();
              trackAction('product_detail_review_load_more');
            }}
          >
            Load More Reviews
          </Button>
        </div>
      )}
    </div>
  );
}

Reviews.propTypes = {
  children: ChildrenProp,
  filters: PropTypes.array,
  onFilterChange: PropTypes.func,
  onLoadMore: PropTypes.func,
  onSortChange: PropTypes.func,
  selectedFilters: PropTypes.object,
  selectedSort: PropTypes.object,
  showLoadMore: PropTypes.bool,
  sortOptions: PropTypes.array
};

export { Review };
export default Reviews;
